<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getRoles"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons>
        <b-button class="ml-2" :to="{ name: 'roles-create' }" variant="primary">
          <i class="lni lni-circle-plus m-0"></i>
        </b-button>
      </template>

      <template v-slot:headings>
        <div class="col-md-9">Name</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-9 my-auto">
          <h5 class="font-weight-bold">{{ slotProps.item.role }}</h5>
        </div>

        <div class="col-md-3 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{ name: 'roles-show', params: { id: slotProps.item.id } }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>

          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{ name: 'roles-edit', params: { id: slotProps.item.id } }"
            class="text-primary table-action-icon"
          >
            <i class="lni lni-pencil"></i>
          </router-link>

          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Delete"
            @click="confirmDelete(slotProps.item.id)"
            class="text-danger table-action-icon"
          >
            <i class="lni lni-trash"></i>
          </span>
        </div>
      </template>
    </data-table>

       <b-modal    
      :hide-footer="true" 
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'roles' })"
      :lazy="true"
      >
       <router-view
          @roleCreated="roleCreated()"
          @roleUpdated="roleUpdated()"
        ></router-view>       
    </b-modal>
  </div>
</template>

<script>
import roleRepo from "@/api/repos/roleRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "role", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "role", label: "Name Asc", order: "asc" },
        { column: "role", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Oldest", order: "asc" },
        { column: "created_at", label: "Newest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getRoles({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
    async deleteRole(id) {
      this.isBusy = true;
      try {
        await roleRepo.delete(id);
        this.items = this.items.filter((item) => item.id !== id);
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the role.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteRole(id) : false))
        .catch((error) => console.log(error));
    },
    async getRoles(e) {
      this.isLoad = true;
      try {
        let { data } = await roleRepo.roles(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.roles.data;
        this.totalRows = data.roles.total;
        this.page = data.roles.current_page;
        this.fromRow = data.roles.from;
        this.toRow = data.roles.to;
        this.lastPage = data.roles.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    roleCreated() {
      this.$bvToast.toast("Role Created", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "created_at",
        label: "Date Created Desc",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getRoles({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
        search: "",
      });
    },

    roleUpdated() {
      this.$bvToast.toast("Role Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getRoles({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
